import View from './ChildrenInfoWorkflowView';

export default View;
